import React from 'react';
import { Link, generatePath } from 'react-router-dom';

const Anchor = ({
  children, to, params, openNewTab, ...rest
}) => {
  const destination = typeof to === 'object' && to.path ? to.path : to;

  return (
    <Link
      to={{
        pathname: params ? generatePath(destination, params) : destination,
        // search: window.location.search,
      }}
      {...rest}
    >
      { children }
    </Link>
  );
};

export default Anchor;
